import React, { Component } from 'react';
import { isEmpty, isEqual, orderBy } from 'lodash';
import {
  Carousel,
  UploadImageModal,
  Loading
} from "common-import/custom";

import { VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import v from "voca";
import moment from "moment";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const Text = [
  "name",
  "description",
  "unitWeight",
  "unitWidth",
  "unitDepth",
  "inventorySKU",
  "inventoryBarcode",
  "inventoryPolicy",
  "brand",
  "shipping",
  "shipsTo"
];

const Number = [
  "price",
  "comparePrice",
  "minDepth",
  "maxDepth",
  "minWeight",
  "maxWeight",
  "minWidth",
  "maxWidth",
  "numberOfSell",
  "sale"
];

const Boolean = [
  "isChargeTaxes",
  "isRequireShip",
  "isNewArrived",
  "approved"
];

const Select = [
  "category",
  "subCategory",
  "subSubCategory",
  "productType"
];

const ListType = [
  "tags",
  "styles",
  "colors",
  "sizes",
  "variants",
  "materials",
  "collections"
];

const propertyProduct = [...Text, ...Number, ...Boolean, ...Select, ...ListType];

@inject("productStore", "userStore", "masterStore") @observer
export default class ImportProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: {},
      isSaving: false,
      openImageModal: false,
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeArray: ["images", "variants", "sizes", "colors", "materials", "tags", "styles", "collections"],
      typeBoolean: ["isChargeTaxes", "isRequireShip", "isNewArrived"],
      typeNumber: ["price", "comparePrice", "minDepth", "maxDepth", "minWeight", "maxWeight", "minWidth", "maxWidth", "sale"],
      typeString: ["name", "description", "category", "subCategory", "subSubCategory", "unitWeight", "unitWidth", "unitDepth", "inventorySKU", "inventoryBarcode", "inventoryPolicy", "productType", "vendor", "brand", "shipping", "shipsTo"]
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  handleCloseModal = () => {
    this.setState({
      openImageModal: false,
    });
  };

  handleOpenModal = () => {
    this.setState({
      openImageModal: true,
    });
  };

  handleSubmitModal = async (list) => {
    const { current } = this.state;
    this.setState({ current: {...current, images: [...list]} });
    this.handleCloseModal();
  };

  saveChanges = async () => {
    const { productStore, match, userStore } = this.props;
    const { current } = this.state;
    let payload = this.formatPayload(current);

    payload = {
      ...payload,
      "ownerType": 'user',
      "ownerId": userStore.userData.id,
    };

    this.setState({ isSaving: true });
    const res = await productStore.create(payload);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error('Created failure: ' + JSON.stringify(res.error));
    }

    this.setState({current: {}});
    window.toast.info('Created successfully.');

    if (!current.approved) return null;

    await productStore.approve({ id: match.params.id, approved: true });
  };

  clearAll = (e) => {
    !!e && e.preventDefault();
    if (window.confirm("Clear all inputs?")) {
      this.setState({current: {}});
    }
  };

  renderUploadForm = () => {
    const { current } = this.state;
    return (
      <div className="block-content">
        <div className="block-content__title">
          <span><i className="fa fa-file"> </i> Images</span>
        </div>
        <div className="block-content__body">
          {/*images*/}
          <label>Images ({(current.images || []).length})</label>
          <div className="input-group" style={{marginBottom:'16px'}}>
            <input type="text" disabled={true} className="form-control"
                   value={!!current.images ? current.images.join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('image')}>Upload</button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  renderFormEdit() {
    const {
      toSelectData,
      product_categories,
      product_categories_lev3,
      product_sub_categories,
      product_type
    } = this.props.masterStore;

    const yesNoSelect = [
      {id: 0, label: 'No', value: 'false'},
      {id: 1, label: 'Yes', value: 'true'}
    ];

    const propMaster = {
      productType: product_type,
      category: product_categories,
      subCategory: product_sub_categories,
      subSubCategory: product_categories_lev3,
      isChargeTaxes: yesNoSelect,
      isRequireShip: yesNoSelect,
      isNewArrived: yesNoSelect,
      approved: yesNoSelect
    };

    const renderOptions = (prop) => {
      let arr = propMaster[prop];
      if (!Boolean.includes(prop)) {
        arr = [{id: 'null', label: '', value: 'null'}, ...orderBy(toSelectData(propMaster[prop]), ['label'],['asc'])];
      }
      return arr.sort().map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    return (<form className="block-content">
      <div className="row">
        {
          propertyProduct.map((property, index) => {
            let element;

            if (property === 'description') {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <textarea
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>
            } else if (Number.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <input
                  type="number"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>
            } else if (Select.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <select
                  id={"nf-" + property}
                  name={"nf-" + property}
                  className="form-control"
                  defaultValue={this.state.current[property]}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                  placeholder={v.capitalize(property)}
                >
                  {renderOptions(property)}
                </select>
              </div>
            } else if (Boolean.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <select
                  id={"nf-" + property}
                  name={"nf-" + property}
                  className="form-control"
                  defaultValue={this.state.current[property] == true ? 1 : 0}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                  placeholder={v.capitalize(property)}
                >
                  {renderOptions(property)}
                </select>
              </div>
            } else if (ListType.includes(property)) {
              const dv = Array.isArray(this.state.current[property]) ? this.state.current[property].join(",") : '';
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)} (*)</label>
                <input
                  type="text"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={dv}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>;
            } else {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <input
                  type="text"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  defaultValue={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>;
            }

            return (
              <div className="col-md-6" key={"property" + index}>
                {element}
              </div>
            );
          })
        }
      </div>
      <p className="text-warning">(*) multiple values, using "," to separate each value.</p>
    </form>)
  };

  render() {
    const { openImageModal, isSaving, current } = this.state;

    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            <div className="card-header-left">
              <span><i className="fa fa-envelope-open"> </i> Create a new Product</span>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-7">
                {this.renderFormEdit()}
              </div>
              <div className="col-md-5">
                {this.renderUploadForm()}
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="button-group">
              <button className="btn btn-sm btn-primary" disabled={isSaving} onClick={this.saveChanges}>
                <i className="fa fa-dot-circle-o"> </i> { isSaving ? 'Saving' : 'Save' }
              </button>
              <button className="btn btn-sm btn-danger" onClick={e => this.clearAll(e)}>
                <i className="fa fa-ban"> </i> Clear
              </button>
            </div>
          </div>
        </div>
        <UploadImageModal
          open={openImageModal}
          list={current.images}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UploadImageModal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Product/Import.js